module.exports = __webpack_public_path__ + "static/media/musica2.41f4a2ef.mp3";